'use strict';

var ModalView = require('./ModalView'),
  arrangePaymentModalTemplate = require('../../tmpl/client/modal/arrangePaymentModal.hbs'),

  ArrangePaymentModalView = ModalView.extend({
    template: arrangePaymentModalTemplate
  });

module.exports = ArrangePaymentModalView;


// WEBPACK FOOTER //
// ./assets/js/components/ArrangePaymentModalView.js